// +----------------------------------------------------------------------
// | CRMEB [ CRMEB 赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB 并不是自由软件，未经许可不能去掉 CRMEB 相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var kingdeePushLogRouter = {
  path: '/kingdeePushLog',
  component: Layout,
  redirect: '/kingdeePushLog/list',
  name: 'KingdeePushLog',
  meta: {
    title: '金蝶推送日志',
    icon: 'el-icon-document',
    noCache: true,
    alwaysShow: true
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/kingdeePushLog/index');
    },
    name: 'KingdeePushLogList',
    meta: {
      title: '金蝶推送日志',
      noCache: true,
      affix: false,
      icon: 'el-icon-document',
      perms: 'api:admin:kingdee:push:list',
      activeMenu: '/kingdeePushLog'
    }
  }],
  // 确保这是一个顶级菜单，不属于任何其他菜单
  pid: 0
};
export default kingdeePushLogRouter;